import { motion } from "framer-motion";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  delay?: number;
  duration?: number;
  style?: {};
}
export function SwipeIn({ children, style, delay = 0, duration = 0.5 }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: duration, delay: delay }}
      style={{ ...style }}
    >
      {children}
    </motion.div>
  );
}
